import { useEffect, useState, useRef } from 'react';
import './style.scss';
import { getProjectDocInfo } from '../../api/document';
import { LeftMenu } from './left-menu';
import { RightCatalogue } from './right-catalogue';
import { DocumentContent } from './document-content';
import { getArea } from '../utils/env';
import {
  IProjectDocInfo,
  IProjectDocInfoMenu,
  IProjectInfo,
  INodeList,
  IDocContentLoadInfo,
  IProjectDocInfoTags,
  IContentNav,
} from '../../model/api-modules/document';
import {
  markdownFormatConvert,
  cherryMarkdown,
  getContentNav,
  goDocAnchorPoint,
  getActiveDocuments,
  getDocuments,
  getDocumentParams,
} from './utils';
import 'cherry-markdown/dist/cherry-markdown.css';
import Cherry from 'cherry-markdown/dist/cherry-markdown.core';
import CherryMermaidPlugin from 'cherry-markdown/dist/addons/cherry-code-block-mermaid-plugin';
import 'viewerjs/dist/viewer.css';
import { HeaderComp } from '../component/header-comp';
// import { PublicHeaderComp } from '../component/public-header-comp';
import { LanguageType, IAppDocPidConfigItem, AppEnvType } from '../../model';
import { getConfig } from '../../config';
import { setTitle } from '../../lib';
import { DocumentHomeLeft } from './document-home/document-home-left';
import { DocumentHomeRight } from './document-home/document-home-right';
// import { getLoginToken } from '../lib';
import { Header } from '../download-center/download-center-header';
import { getUserInfoDoc } from '../../api';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../store/modules/common';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { IAPIUserInfo } from '../../model/api-modules';
const { mermaid } = window;
// eslint-disable-next-line
Cherry.usePlugin(CherryMermaidPlugin, { mermaid });

interface IDocProps {
  readonly isDocPublicRoute: boolean;
}

export const DocumentDetail = (props: IDocProps) => {
  const commonDispatch = useDispatch<Dispatch<CommonAction>>();
  const hashAnchorPoint = decodeURIComponent(location.hash);
  const [projectDocInfo, setProjectDocInfo] = useState<IProjectDocInfo>();
  const [simpleProjectDocInfo, setSimpleProjectDocInfo] =
    useState<IProjectDocInfo>();
  const [selectActive, setSelectActive] = useState<ReadonlyArray<number>>([]);
  const [currentProject, setCurrentProject] = useState<IProjectInfo>();
  const [inductionTags, setInductionTags] =
    useState<ReadonlyArray<IProjectDocInfoTags>>();
  const [tagIsExists, setTagIsExists] = useState<boolean>(false);
  const [isDocLoading, setIsDocLoading] = useState<boolean>(false);
  const [currentDocument, setCurrentDocument] = useState<IProjectDocInfoMenu>();
  const [contentNav, setContentNav] = useState<ReadonlyArray<IContentNav>>();
  const [nodeList, setNodeList] = useState<INodeList>({ idList: [], node: [] });
  // isShowContentDom是否显示content内容div，显示的时候editormd解析成html isDone是否解析完成，主要避免页面闪烁的效果
  const [docContentLoadInfo, setDocContentLoadInfo] =
    useState<IDocContentLoadInfo>({ isShowContentDom: true, isDone: true });
  const docContentLoadInfoRef = useRef(docContentLoadInfo);
  const docContentRef = useRef(false);
  const [projectContentLoadInfo, setProjectContentLoadInfo] =
    useState<IDocContentLoadInfo>({ isShowContentDom: true, isDone: true });
  const projectContentLoadInfoRef = useRef<IDocContentLoadInfo>(
    projectContentLoadInfo
  );
  const projectContentRef = useRef(false);
  const [anchorTitleId, setAnchorTitleId] = useState<string>('');
  const [userInfo, setUserInfo] = useState<IAPIUserInfo | null>(null);
  // 保存当前项目的全部文档列表
  // const [documents, setDocuments] = useState<>();
  const [hotDocument, setHotDocument] =
    useState<ReadonlyArray<IProjectDocInfoMenu>>();
  // const nodeListRef = useRef(nodeList);
  const { projectId, docId } = getDocumentParams();
  // const currentUrlParams = new URLSearchParams(window.location.search);
  // const projectId = currentUrlParams.get('projectId');
  // const docId = currentUrlParams.get('docId');
  const showHome = Boolean(projectId && !docId);
  //   const activeDocuments = useMemo(() => getActiveDocuments(getDocuments(projectDocInfo?.menu), [docId])
  const [activeDocuments, setActiveDocuments] =
    useState<ReadonlyArray<IProjectDocInfoMenu>>();
  let langConfig: IAppDocPidConfigItem;
  (getConfig()?.documentConfig?.modules || []).forEach((item) => {
    if (item.pid.en_US === +projectId || item.pid.zh_CN === +projectId) {
      langConfig = item.pid;
    }
  });
  // const langConfig = (getConfig()?.docConfig?.projectID || []).find((v) =>
  //   Object.values(v).includes(+projectId)
  // );
  const [lang, setLang] = useState<LanguageType | null>(null);
  const isProd = process.env.REACT_APP_ENV === AppEnvType.Production;
  // const isShowHome =
  //   (isProd && (projectId === '35' || projectId === '36')) ||
  //   (!isProd && (projectId === '38' || projectId === '39'));
  const isShowHome = projectId === '35' || projectId === '36';
  // const testShow =
  //   !isProd &&
  //   ((projectId === '38' && docId === '1055') ||
  //     (projectId === '39' && docId === '1012'));
  const testShow =
    !isProd &&
    ((projectId === '35' && docId === '1103') ||
      (projectId === '36' && docId === '1006'));
  const prodShow =
    isProd &&
    ((projectId === '35' && docId === '1103') ||
      (projectId === '36' && docId === '1006'));
  const isShowServices = testShow || prodShow;

  const getUserInfo = async () => {
    const res = await getUserInfoDoc(true);
    if (res) {
      setUserInfo(res);
      commonDispatch({
        type: ReduxCommonActionType.LOGIN,
        result: res,
      });
    }
  };

  // 插件注册必须在Cherry实例化之前完成
  useEffect(() => {
    getUserInfo();
    getSimpleProjectDoc();
    getProjectDoc();
    getCurrentLang();
    setTitle('Tencent Games InGame');
  }, []);

  useEffect(() => {
    // setDocuments(getDocuments(projectDocInfo?.menu));
    setHotDocument(
      getDocuments(projectDocInfo?.menu)
        .sort(
          (a: IProjectDocInfoMenu, b: IProjectDocInfoMenu) =>
            Number(b.visit_count) - Number(a.visit_count)
        )
        .splice(0, 5)
    );
    setActiveDocumentsValue();
  }, [projectDocInfo?.menu]);

  useEffect(() => {
    setActiveDocumentsValue();

    if (docId) {
      setSelectActive([Number(docId)]);
    } else {
      setSelectActive([]);
    }
  }, [docId]);

  const setActiveDocumentsValue = () => {
    setActiveDocuments(
      getActiveDocuments(getDocuments(projectDocInfo?.menu), docId)
    );
  };

  useEffect(() => {
    watchCurrentDocument();
  }, [currentDocument, currentProject]);

  useEffect(() => {
    if (currentProject) {
      watchCurrentProjectShowInfo();
    }
  }, [showHome, currentProject, isDocLoading]);

  const computedCurrentDocument =
    activeDocuments && activeDocuments[activeDocuments.length - 1];

  useEffect(() => {
    setCurrentDocument(computedCurrentDocument);
  }, [computedCurrentDocument]);

  useEffect(() => {
    const updatedTagsList: Array<object> = [];
    inductionTags &&
      inductionTags?.length > 0 &&
      inductionTags.forEach((tagItem: IProjectDocInfoTags) => {
        updatedTagsList.push(...tagItem.list);
      });
    setTagIsExists(updatedTagsList.length > 0);
  }, [inductionTags]);

  const getCurrentLang = () => {
    if (!projectId) return;
    if (langConfig) {
      const isZh = +projectId === langConfig.zh_CN;
      setLang(isZh ? LanguageType.ZH : LanguageType.EN);
    }
  };

  // const getAllNodes = (nodes: ReadonlyArray<IProjectDocInfoMenu>) => {
  //   nodes.forEach((node: IProjectDocInfoMenu) => {
  //     const { idList } = nodeList;
  //     if (node.nodes.length > 0) {
  //       getAllNodes(node.nodes);
  //     }
  //     if (idList.indexOf(node.id) < 0) {
  //       const newNodeList: any = Object.assign({}, nodeListRef.current);
  //       newNodeList.idList.push(node.id);
  //       newNodeList.node.push(node);
  //       nodeListRef.current = newNodeList;
  //       setNodeList(Object.assign({}, nodeListRef.current));
  //     }
  //   });
  // };
  const getAllNodes = (nodes: ReadonlyArray<IProjectDocInfoMenu>) => {
    const result: any = { idList: [], node: [] };

    const traverse = (nodelist: ReadonlyArray<IProjectDocInfoMenu>) => {
      nodelist.forEach((node) => {
        if (!result.idList.includes(node.id)) {
          result.idList.push(node.id);
          result.node.push(node);
        }
        if (node.nodes && node.nodes.length > 0) {
          traverse(node.nodes);
        }
      });
    };

    traverse(nodes);
    return result;
  };

  const getSimpleProjectDoc = async () => {
    setIsDocLoading(true);
    const res = await getProjectDocInfo({
      area: getArea(),
      proxy_doc: 1,
      projectId,
      simplified: 1,
    });
    if (res) {
      setIsDocLoading(false);
      setSimpleProjectDocInfo(res);
    }
  };

  const getProjectDoc = async () => {
    setIsDocLoading(true);
    const res = await getProjectDocInfo({
      area: getArea(),
      proxy_doc: 1,
      projectId,
    });
    if (res) {
      setIsDocLoading(false);
      setProjectDocInfo(res);
      const timer = Date.now();
      // getAllNodes(res.menu);
      const fullNodeList = getAllNodes(res.menu);
      setNodeList(fullNodeList);
      console.log('doc-getAllNodes', Date.now() - timer);
      setCurrentProject(res.project_info);
      setInductionTags(res.tags_list);
    }
  };

  const watchCurrentDocument = () => {
    // const token = getLoginToken();
    if (currentDocument?.visibility === 1 || userInfo) {
      // 防止设置两次setTimeout
      if (docContentRef.current) return;
      if (currentDocument && !isDocLoading) {
        // const currentContentNav = [];
        // const starNum = 0;
        // 未经过处理的content, 用于下载md文件（ 保存解析前数据）
        // const originalContent = value.content;
        const document = markdownFormatConvert(
          currentDocument.content,
          nodeList,
          currentProject
        );
        docContentLoadInfoRef.current.isShowContentDom = false;
        docContentLoadInfoRef.current.isDone = false;
        setDocContentLoadInfo({
          isShowContentDom: false,
          isDone: false,
        });
        // 显示新doc文档内容时先销毁之前的dom(isShowContentDom用于销毁)，不销毁editormd转换会把之前的文档内容也显示，还会有其他异常（代码报错，页面卡死等）
        setTimeout(() => {
          docContentLoadInfoRef.current.isShowContentDom = true;
          docContentLoadInfoRef.current.isDone = false;
          setDocContentLoadInfo({
            isShowContentDom: true,
            isDone: false,
          });
          setTimeout(() => {
            const timer = Date.now();
            const res = cherryMarkdown('docContentBox', document);
            console.log('doc-cherryMarkdown-init', Date.now() - timer);
            docContentLoadInfoRef.current.isShowContentDom = true;
            docContentLoadInfoRef.current.isDone = true;
            // 延时一段时间显示（主要是图片加载，数字公式转换要一段时间，避免页面闪烁）
            setDocContentLoadInfo({
              isShowContentDom: true,
              isDone: true,
            });
            // 转换html的代码（不包括 katex， katex是转换成功之后页面才操作转换的）(不过不影响后面getContentNav，getContentNav只获取h标签信息)
            // const docHtmlStr = res.getMarkdownParsed();
            // 后面getContentNav，getContentNav只获取h标签信息
            const docHtmlStr = res.getHtml();
            const newContentNav = getContentNav(docHtmlStr);
            setContentNav(newContentNav);
            // 主要是刷新页面时用到，跳转到具体的文档内容锚点
            goDocAnchorPoint(hashAnchorPoint, newContentNav, setAnchorTitleId);
            docContentRef.current = false;
          }, 80);
        }, 80);
        docContentRef.current = true;
      } else {
        // 不需要显示的时候删除之前的内容
        const docContentBox = document.getElementById('docContentBox');
        if (docContentBox) {
          docContentBox.innerHTML = '';
        }
      }
    }
  };

  const watchCurrentProjectShowInfo = () => {
    // 防止设置两次setTimeout
    if (projectContentRef.current) return;
    if (showHome && currentProject && !isDocLoading) {
      const projectContent = markdownFormatConvert(
        currentProject.content,
        nodeList,
        currentProject
      );
      projectContentLoadInfoRef.current.isShowContentDom = false;
      projectContentLoadInfoRef.current.isDone = false;
      setProjectContentLoadInfo({
        isShowContentDom: false,
        isDone: false,
      });
      // 显示新项目内容时先销毁之前的dom(isShowContentDom用于销毁)，不销毁editormd转换会把之前的文档内容也显示，还会有其他异常（代码报错，页面卡死等）
      setTimeout(() => {
        projectContentLoadInfoRef.current.isShowContentDom = true;
        projectContentLoadInfoRef.current.isDone = false;
        setProjectContentLoadInfo({
          isShowContentDom: true,
          isDone: false,
        });
        setTimeout(() => {
          const timer = Date.now();
          cherryMarkdown('projectContentBox', projectContent);
          console.log('doc-cherryMarkdown-init-1', Date.now() - timer);
          projectContentLoadInfoRef.current.isShowContentDom = true;
          projectContentLoadInfoRef.current.isDone = true;
          // 延时一段时间显示（主要是图片加载，数字公式转换要一段时间，避免页面闪烁）
          setProjectContentLoadInfo({
            isShowContentDom: true,
            isDone: true,
          });
          projectContentRef.current = false;
        }, 100);
      }, 150);
      projectContentRef.current = true;
    } else {
      const projectContentBox = document.getElementById('projectContentBox');
      if (projectContentBox) {
        projectContentBox.innerHTML = '';
      }
    }
  };

  const renderHomeLeft = () => {
    return (
      <DocumentHomeLeft
        isDocPublicRoute={props.isDocPublicRoute}
        projectDocInfo={simpleProjectDocInfo}
        lang={lang}
      />
    );
  };
  const renderHomeRight = () => {
    return (
      <DocumentHomeRight
        projectDocInfo={simpleProjectDocInfo}
        isDocPublicRoute={props.isDocPublicRoute}
        lang={lang}
      />
    );
  };

  const isShowContent = () => {
    // const token = getLoginToken();
    // visibility: 1 可免登录查看
    if (currentDocument?.visibility === 1 || userInfo) {
      return true;
    }
    return false;
  };
  return (
    <>
      {<Header lang={lang} />}
      {/* {props.isDocPublicRoute || !token ? (
        <PublicHeaderComp lang={lang} />
      ) : ( */}
      <HeaderComp
        isDocPublicRoute={props.isDocPublicRoute}
        showUpgradeNotice={false}
      />
      {/* )} */}
      {!docId && isShowHome && (
        <div className="document-home">
          {renderHomeLeft()}
          {renderHomeRight()}
        </div>
      )}
      <div
        className="main-content"
        style={{ display: docId ? 'flex' : 'none' }}
      >
        <LeftMenu
          projectDocInfo={projectDocInfo}
          selectActive={selectActive}
          isDocPublicRoute={props.isDocPublicRoute}
          isShowHome={isShowHome}
        />
        <div className="c-main-content-wapper">
          <div className="placeholder-box"></div>
          {currentProject && (
            <DocumentContent
              currentProject={currentProject}
              currentDocument={currentDocument}
              activeDocuments={activeDocuments}
              tagIsExists={tagIsExists}
              inductionTags={inductionTags}
              hotDocument={hotDocument}
              projectContentLoadInfoRef={projectContentLoadInfoRef}
              docContentLoadInfoRef={docContentLoadInfoRef}
              projectDocInfo={projectDocInfo}
              contentNav={contentNav}
              activeId={anchorTitleId}
              setActiveId={setAnchorTitleId}
              setSelectActive={setSelectActive}
              lang={lang}
              isDocPublicRoute={props.isDocPublicRoute}
            />
          )}
          {!isShowServices && projectId && docId && isShowContent() && (
            <RightCatalogue
              projectDocInfo={projectDocInfo}
              contentNav={contentNav}
              activeId={anchorTitleId}
              setActiveId={setAnchorTitleId}
              isRight={true}
              lang={lang}
            />
          )}
          <div className="placeholder-box"></div>
        </div>
      </div>
    </>
  );
};
